/**
 * Format a large number into a compact representation.
 * Examples: 1000 → "1K", 15000 → "15K", 1000000 → "1M"
 */
export function formatNumber(n) {
  const num = Math.round(parseFloat(n) || 0);
  if (num >= 1_000_000) {
    const v = num / 1_000_000;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)) + 'M';
  }
  if (num >= 1_000) {
    const v = num / 1_000;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)) + 'K';
  }
  return String(num);
}
